import {DashboardSection} from '@npck/af-frontend-api';

export const INCIDENT_SECTIONS: DashboardSection[] = [
    DashboardSection.INCIDENT_FRAUD,
    DashboardSection.INCIDENT_DRUG,
    DashboardSection.INCIDENT_PYRAMID_SCHEME,
    DashboardSection.INCIDENT_CASINO,
];

export function sectionToSlug(section: DashboardSection): string {
    return section.toLowerCase().replace(/_/g, '-');
}

export function slugToSection(slug: string | null): DashboardSection {
    return INCIDENT_SECTIONS.find(section => sectionToSlug(section) === slug) ?? DashboardSection.INCIDENT_FRAUD;
}

export function sectionTitleKey(section: DashboardSection): string {
    const name = sectionToSlug(section)
        .split('-')
        .map(part => part.charAt(0).toUpperCase() + part.slice(1))
        .join('');
    return `i18n_lib_breadcrumb#${name}`;
}
